module.exports = (parcelRequire.load("ccUj9")).then(() => parcelRequire('jsX6u'));